<template>
    <div class="footer py-2">
        <div class="max-w-1200 m-0-auto">
            <v-row>
                <v-col cols="12" sm="12" md="6" lg="4">
                    <div class="d-flex justify-center">
                        <div class="text-center pr-3">
                            <img src="@/assets/icons/ring.png" alt="" height="60">
                        </div>
                        <div>
                            <div class="primary--text">WEDDING</div>
                            <div class="text-xs">Find the best suppliers for your special day</div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="4">
                    <div class="d-flex justify-center">
                        <div class="text-center pr-3">
                            <img src="@/assets/icons/Travel.png" alt="" height="60">
                        </div>
                        <div>
                            <div class="primary--text">TRAVEL</div>
                            <div class="text-xs">Explore amazing deals and destinations</div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="4">
                    <div class="d-flex justify-center">
                        <div class="text-center pr-3">
                            <img src="@/assets/icons/confetti.png" alt="" height="60">
                        </div>
                        <div>
                            <div class="primary--text">CELEBRATIONS</div>
                            <div class="text-xs">Plan unforgettable events and parties</div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FooterTwo',
}
</script>
<style scoped>
.footer {
    background: #f8efea;
}

.text-gold {
    color: #9c6b00;
}
</style>